/**
 * @author: lyw
 * @date 2022-04-12
 * @description: sessionstorage.js
*/

let prefix = `${process.env.NODE_ENV}_RENTAL_OAUTH_BE_`

export default {
    key: {
        SYSTEM_MENU_PERMISSIONS_ROOT_LIST: prefix + 'SYSTEM_MENU_PERMISSIONS_ROOT_LIST',
        SYSTEMROLES: prefix + 'SYSTEMROLES',
    },
    setMenuRootlist: function(data) {
        sessionStorage.setItem(this.key.SYSTEM_MENU_PERMISSIONS_ROOT_LIST, JSON.stringify(data));
    },
    getMenuRootlist: function() {
        var author = sessionStorage.getItem(this.key.SYSTEM_MENU_PERMISSIONS_ROOT_LIST);
        return !!author ? JSON.parse(author) : null;
    },
    clearMenuRootlist: function() {
        sessionStorage.removeItem(this.key.SYSTEM_MENU_PERMISSIONS_ROOT_LIST);
    },
    setSystemRolest: function(data) {
        sessionStorage.setItem(this.key.SYSTEMROLES, JSON.stringify(data));
    },
    getSystemRoles: function() {
        var author = sessionStorage.getItem(this.key.SYSTEMROLES);
        return !!author ? JSON.parse(author) : null;
    },
    clearSystemRoles: function() {
        sessionStorage.removeItem(this.key.SYSTEMROLES);
    },
}